import React from 'react'
import './sign-up-success-component.scss'

class SignupSuccessComponent extends React.Component {
  state = {}

  render() {
    const { name } = this.props
    return (
      <div className="signup-component-success">
        <div className='row maths-day-container'>
          <div class='maths-day-description signup-success-description'>
            <p className='slogan-text'>Hello, {name}</p>
            <p>
              Your school registration for Countingwell's Homework Platform is now complete.

              Your application is currently under review and you will receive a notification once it is approved, after which you can start assigning homework and revision for examinations to your students free of cost.

              We typically review and respond within 1 working day. Please check your email for a confirmation message.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default SignupSuccessComponent
